import { API_BASE_URL } from '@/environment'
import { customFetch } from '@/service/v3/apiV3Utils'
import type { GetUsersByGroupIdParams } from '@/service/v3/endpoints/groupsParams'
import { queryParams } from '@attensi/utils'

const API_ADMIN_NAMESPACE = 'api/v3/admin'

export const getUsersByGroupId = async ({
  groupId,
  pagination,
  sortBy,
  sortDesc,
  filterTerm,
}: GetUsersByGroupIdParams) => {
  const groupsQueryParams = {
    ...pagination,
    ...(sortBy ? { sort: `${sortDesc ? '-' : ''}${sortBy}` } : {}),
    'filter[term]': filterTerm,
  }

  const url = queryParams(
    `${API_BASE_URL}/${API_ADMIN_NAMESPACE}/groups/${groupId}/users`,
    groupsQueryParams
  )

  const usersResponse = await customFetch(url, { method: 'GET' })
  if (!usersResponse.ok) {
    throw usersResponse
  }
  return usersResponse.json()
}
